import { client, DEFAULT_HEADERS } from "./defaultClient";
import { ActivityReply } from "./generated";

export const getActivityReplies = async (
    activityId: string
): Promise<ActivityReply[]> =>
    await client.getActivityIdActivityReplies(
        { id: activityId },
        { mode: "cors" }
    );

export const getActivityReply = async (
    activityReplyId: string
): Promise<ActivityReply> =>
    await client.getActivityReplyId({ id: activityReplyId }, { mode: "cors" });

export const addCommentOnActivityReply = async (
    activityReplyId: string,
    text: string,
    imagePaths: Array<string>,
    csrfToken: string
): Promise<ActivityReply> =>
    await client.patchActivityReplyActivityReplyIdComment(
        { activityReplyId, newComment: { text, imagePaths } },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );

export const updateLastWatchedAt = async (
    id: string,
    csrfToken: string
): Promise<ActivityReply> => {
    return await client.patchActivityReplyIdLastWatchedAt(
        { id },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );
};

export const getActivityRepliesUnreadStatus = async (): Promise<
    {
        activityId: string;
        activityReplyId: string;
        isUnread: boolean;
    }[]
> => await client.getActivityRepliesUnreadStatus({ mode: "cors" });

export const getSignedUrlForCommentImages = async (
    files: File[],
    csrfToken: string
) => {
    const fileInfos = files.map((file) => {
        return {
            fileName: file.name,
            fileExtension: file.type.split("/")[1] ?? "",
            contentType: file.type,
        };
    });

    const response = await client.postActivityReplyCommentImagesSignedurl(
        {
            postMemoryCommentImagesSignedurlRequest: { fileInfos },
        },
        {
            mode: "cors",
            headers: {
                ...DEFAULT_HEADERS,
                "X-CSRF-Token": csrfToken,
            },
        }
    );
    return response;
};
